module.exports = __webpack_public_path__ + "static/media/hotel-ad6.2d80e4d0.jpg";